// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as TailwindMerge from "tailwind-merge";
import * as HtmlBody$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HtmlBody.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as TooltipPosition$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/TooltipPosition.res.mjs";
import * as V3TooltipContext$LiteracyplanetTupperware from "./V3TooltipContext.res.mjs";
import * as ContainerDimensions$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContainerDimensions.res.mjs";

function V3Tooltip$Trigger(props) {
  var id = props.id;
  var match = V3TooltipContext$LiteracyplanetTupperware.useTrigger();
  var isOver = match.isOver;
  var onLeave = match.onLeave;
  var onEnter = match.onEnter;
  var match$1 = ContainerDimensions$LiteracyplanetClientFlags.useDimsWithContent(isOver);
  var match$2 = TooltipPosition$LiteracyplanetClientFlags.use(match$1[1]);
  return React.createElement("div", {
              ref: Caml_option.some(match$1[0]),
              className: "relative tooltip-trigger",
              onMouseEnter: (function (param) {
                  onEnter(id);
                }),
              onMouseLeave: (function (param) {
                  onLeave(id);
                })
            }, props.children, React.createElement(HtmlBody$LiteracyplanetClientFlags.make, {
                  children: React.createElement("div", {
                        ref: Caml_option.some(match$2[0]),
                        className: TailwindMerge.twMerge(isOver === id ? "" : "invisible", "tooltip-popup", match$2[1])
                      }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                            id: id,
                            children: null
                          }))
                }));
}

var Trigger = {
  make: V3Tooltip$Trigger
};

function V3Tooltip$Title(props) {
  var id = props.id;
  var match = V3TooltipContext$LiteracyplanetTupperware.useConsumer();
  if (match.isOver === id) {
    return React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
                id: id,
                children: React.createElement("div", {
                      className: "font-bold flex justify-center"
                    }, props.children)
              });
  } else {
    return null;
  }
}

var Title = {
  make: V3Tooltip$Title
};

function V3Tooltip$Description(props) {
  var id = props.id;
  var match = V3TooltipContext$LiteracyplanetTupperware.useConsumer();
  if (match.isOver === id) {
    return React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
                id: id,
                children: React.createElement("div", {
                      className: "text-sm"
                    }, props.children)
              });
  } else {
    return null;
  }
}

var Description = {
  make: V3Tooltip$Description
};

function V3Tooltip(props) {
  var children = props.children;
  var kind = props.kind;
  var id = props.id;
  if (kind === "TooltipTrigger") {
    return React.createElement(V3Tooltip$Trigger, {
                id: id,
                children: children
              });
  } else if (kind === "TooltipTitle") {
    return React.createElement(V3Tooltip$Title, {
                id: id,
                children: children
              });
  } else {
    return React.createElement(V3Tooltip$Description, {
                id: id,
                children: children
              });
  }
}

var make = V3Tooltip;

var $$default = V3Tooltip;

export {
  Trigger ,
  Title ,
  Description ,
  make ,
  $$default as default,
}
/* react Not a pure module */
